import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserProfile } from "../../../user-profile/user-profile.thunks";
import store, { waitForCart, waitForUser } from "../../../../store/store";
import { StoreState } from "../../../../store/store.interface";
import { isSuccessUser } from "../../../user-profile/user-profile.selectors";
import { getCustomerToken } from "../../../customer/customer";
import { validateUserConnectLicenseMagentoApiCall } from "../api/validate-user-connect-license.api";

export const validateLoggedInUserConnectLicense = createAsyncThunk('shopCart/validateLoggedInUserConnectLicense', async (isbn13: string, thunkAPI) => {
  try {
    thunkAPI.dispatch(fetchUserProfile());
    await waitForUser();
    let response: any = undefined;
    const state = store.getState() as StoreState;
  
    if (!isSuccessUser(state)) {
      throw new Error('User is not logged in.');
    }
  
    const stateForMagento = thunkAPI.getState() as StoreState;
    response = await validateUserConnectLicense(isbn13, stateForMagento);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}, {
  condition: (async (_arg) => {
    await waitForCart();
    return true;
  })
});
  
async function validateUserConnectLicense(
  isbn13: string,
  state: StoreState
) {
  const customerToken = getCustomerToken(state);
  
  return await validateUserConnectLicenseMagentoApiCall(
    isbn13,
    customerToken,
  );
}